import {TOWNS_SET_ALL, TOWNS_SET_TO} from '../constants/actionTypes';
import {ERR_COMMUNICATION, ERR_UNKNOWN} from '../constants/errors';
import {fetchMB} from '../utils/MojBus'

export function setAllTowns(towns){
  return {
    type: TOWNS_SET_ALL,
    towns
  }
}
export function setToTowns(towns){
  return {
    type: TOWNS_SET_TO,
    towns
  }
}

export function fetchTowns(agentLogin, townFrom=''){
  let apiTowns={
    agent: agentLogin,
  }
  if (townFrom !=='')
    apiTowns={
      ...apiTowns,
      townFrom
    }
//  console.log('Fetch Towns', apiTowns)

  return dispatch => {
    let funcError=function(error){
      // return alert('Error');
      return dispatch(error(ERR_UNKNOWN))
    }

    fetchMB('towns', apiTowns, false)
    .then(
      function(json){
        if (json.status==='OK'){
          if (townFrom==='')
            return dispatch(setAllTowns(json.towns))
          else
            return dispatch(setToTowns(json.towns))
        }
        else
          funcError()
      },
      function(error){
        return dispatch(error(ERR_COMMUNICATION))
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/townsActions.js